import React from "react";
import CustomTable from "../customTable";
import { ResultsPerCampaignsColumns } from "./columns/ResultsPerCampaignsColumns";
import Comments from "../comments";

const ResultsPerCampaigns = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerCampaignsColumns}
        data={processedData?.results_per_campaigns?.data || []}
        totalAggregatedData={processedData?.results_per_campaigns?.totals || {}}
        loading={loading}
        storageKey={"resultspercampaigns"}
      />
      <Comments tab_name="Results per campaigns" />
    </div>
  );
};

export default ResultsPerCampaigns;
